// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3xO8g","tabs_wrapper":"styles_tabs_wrapper__39f4k","tab":"styles_tab__baICN","active":"styles_active__1mBuS"};